import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  Button,
  tokens,
} from '@fluentui/react-components';
import { PersonLockRegular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';

interface UnauthenticatedBannerProps {
  /** The feature name shown in the banner, e.g. "dashboard data" */
  feature?: string;
}

/**
 * A shared banner shown when a page cannot load data because the user
 * is not signed in (API returned 401 or auth is not configured).
 *
 * Uses warning intent (not error) to avoid alarming users.
 */
export function UnauthenticatedBanner({ feature = 'this feature' }: UnauthenticatedBannerProps) {
  const navigate = useNavigate();

  return (
    <MessageBar intent="warning" icon={<PersonLockRegular />}>
      <MessageBarBody>
        <MessageBarTitle>Sign in required</MessageBarTitle>
        <span style={{ color: tokens.colorNeutralForeground1 }}>
          Sign in to access {feature}. Your data is secured and requires authentication.
        </span>
        <Button
          appearance="primary"
          size="small"
          style={{ marginLeft: tokens.spacingHorizontalM }}
          onClick={() => navigate('/login')}
        >
          Sign In
        </Button>
      </MessageBarBody>
    </MessageBar>
  );
}
